import { OnDestroy } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/flex-layout/core";
var ScreenSizeService = /** @class */ (function () {
    // #endregion
    function ScreenSizeService(mediaService) {
        var _this = this;
        this.mediaService = mediaService;
        this._subrelease = new Subject();
        // Set the initial upkeep
        var info = {
            Alias: '',
            IsSmallSize: false,
            IsXs: this.mediaService.isActive('xs'),
            IsSm: this.mediaService.isActive('sm'),
            IsMd: this.mediaService.isActive('md'),
            IsLg: this.mediaService.isActive('lg'),
            IsXl: this.mediaService.isActive('xl'),
        };
        info.IsSmallSize = info.IsXs || info.IsSm;
        info.Alias = info.IsXs ? 'xs' : info.IsSm ? 'sm' : info.IsMd ? 'md' : info.IsLg ? 'lg' : 'xl';
        this._ScreenSizeSub = new BehaviorSubject(info);
        // Set up the subscription to keep up changes
        this.mediaService.media$.pipe(takeUntil(this._subrelease)).subscribe(function (media) {
            var obsinfo = {
                Alias: media.mqAlias,
                IsSmallSize: media.mqAlias === 'xs' || media.mqAlias === 'sm',
                IsXs: media.mqAlias === 'xs',
                IsSm: media.mqAlias === 'sm',
                IsMd: media.mqAlias === 'md',
                IsLg: media.mqAlias === 'lg',
                IsXl: media.mqAlias === 'xl',
            };
            _this._ScreenSizeSub.next(obsinfo);
        });
    }
    Object.defineProperty(ScreenSizeService.prototype, "ScreenSize", {
        // #region Getters
        get: function () {
            return this._ScreenSizeSub.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScreenSizeService.prototype, "ScreenSizeSub", {
        get: function () {
            return this._ScreenSizeSub;
        },
        enumerable: true,
        configurable: true
    });
    ScreenSizeService.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    ScreenSizeService.ngInjectableDef = i0.defineInjectable({ factory: function ScreenSizeService_Factory() { return new ScreenSizeService(i0.inject(i1.MediaObserver)); }, token: ScreenSizeService, providedIn: "root" });
    return ScreenSizeService;
}());
export { ScreenSizeService };
// #region Custom Classes
// #region Screen Size Info Class
var ScreenSizeInfo = /** @class */ (function () {
    function ScreenSizeInfo() {
    }
    return ScreenSizeInfo;
}());
export { ScreenSizeInfo };
